module.exports = __webpack_public_path__ + "static/media/luggers-with-boxes.ccff7ef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/luggers-with-boxes.png
// module id = 1209
// module chunks = 27